import React from "react";
import "./error.scss";
import ErrorImage from "../../assets/images/error.svg";
import { useHistory } from "react-router-dom";
import i18n from "utils/I18n";
import { onlyShowWhiteListPage, NO_WEBAPP_WHITE_PAGE_LIST } from 'utils/UIConfigUtils'
import { navigateBackHomePage } from 'utils/WeChatUtil'

export default function NotFoundPage() {
  const history = useHistory();
  
  const defaultPageButton = () => {
    const onlyShowWhitePage = onlyShowWhiteListPage();
    if (onlyShowWhitePage && !NO_WEBAPP_WHITE_PAGE_LIST.includes("/home")) {
      return null;
    }
    return (
      <button
        className="back-home-button button-large"
        onClick={() => {
          navigateBackHomePage({ history })
        }}
      >
        <label>{i18n.t("back_to_home")}</label>
      </button>
    )
  }

  return (
    <div className="nothing-area">
      <img alt="" src={ErrorImage} />

      <label className="nothing-title title-medium-2">{i18n.t("page_not_found")}</label>

      <label className="nothing-content field-text">{i18n.t("cannnot_find_page")}</label>
      { defaultPageButton() }
    </div>
  );
}
